class TabSlider extends HTMLElement {
    constructor() {
      super();
      this.current = this.querySelector('[id^="tab-slider-image-"]');
      this.tabs = this.querySelectorAll(".tab");
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
          let target = e.currentTarget;
  
          if (target.classList.contains("active")) {
            return;
          } else {
            this.current.src = target.closest(".tab").dataset.image;
          }
  
          this.tabs.forEach((item) => clearClass(item, "active"));
          setClass(target, "active");
        });
      });
  
      function clearClass(node, className) {
        node.classList.remove(className);
      }
  
      function setClass(node, className) {
        node.classList.add(className);
      }
    }
  }
  
  customElements.define("tab-slider", TabSlider);